import service from '@/utils/server';

const modName='/log/logDashboardDetail/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/int/logDashboardDetail/api/index.js